import { render, staticRenderFns } from "./EvaluationTable.vue?vue&type=template&id=0924061e&scoped=true"
import script from "./EvaluationTable.vue?vue&type=script&lang=js"
export * from "./EvaluationTable.vue?vue&type=script&lang=js"
import style0 from "./EvaluationTable.vue?vue&type=style&index=0&id=0924061e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0924061e",
  null
  
)

export default component.exports